<template>
	<div class="filter">
		<div class="filter-title">
			<h1>Investidores</h1>
		</div>
		<div class="filter-inputs">
			<GenericMultiselect
				class="status-multiselect"
				:customClass="'mt-0'"
				ref="status"
				:options="statusOptions"
				:placeholder="'Status'"
				:fullWidth="!isWeb"
				:searchable="false"
				:needType="true"
				:type="'status'"
				:clearOnOpen="false"
				@changeInput="changeInput"
			/>
			<input
				class="filter-inputs__investors"
				type="text"
				placeholder="Busca"
				@input="searchInputDebounce"
				v-model="searchInput"
			/>
			<ButtonPrimary
				class="filter-inputs__btn"
				label="Adicionar Investidor"
				size="md"
				@click="addInvestor"
			/>
		</div>
	</div>
</template>

<script>
import GenericMultiselect from '@/components/shared/GenericMultiselect/GenericMultiselect.vue';
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';

export default {
	name: 'TableFilter',
	components: { GenericMultiselect, ButtonPrimary },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		searchInput: null,
		debounce: null,
	}),
	created() {},
	mounted() {},
	methods: {
		addInvestor() {
			this.$router.push({
				path: '/dashboard/investor/detail',
			});
		},
		changeInput(param) {
			let selectedStatus = !param.value ? null : param.value.name;
			this.$emit('searchFromInput', selectedStatus);
		},
		searchInputDebounce() {
			clearTimeout(this.debounce);

			this.debounce = setTimeout(() => {
				this.$emit('searchFromInput', this.searchInput);
			}, 600);
		},
	},
	computed: {
		statusOptions() {
			const options = [
				{
					id: 1,
					name: 'Aprovado',
				},
				{
					id: 2,
					name: 'Pendente',
				},
			];

			return !options.length ? [] : options;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'TableFilter.scss';
</style>
